(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'HotelBooking',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.confirmation = function confirmation(response)
	{
		Adzuki.Erez.ClientDuplicateEmail.confirm(response, form.name);
	};

	form.load = function load($form)
	{
		var $saved_cards        = $form.find('.credit-cards'),
		    $saved_cards_parent = $saved_cards.parents('.form-group'),
		    $cc_card_type       = $("#hotelbooking-credit_card_type"),
		    $cc_number          = $("#hotelbooking-credit_card_number"),
		    // $cc_verified        = $("#hotelbooking-card_verified"),
		    $cc_verify          = $form.find('.verify-card'),
		    $cc_remove_card     = $form.find('.remove-verified-card'),
		    $cc_card_info       = $form.find('.verified-card-info'),
		    $amex_card_types    = $form.find('.amex-card-types'),
		    $existing_client_id = $form.find('.existing-client-hidden-id'),
		    $prepay_notice      = $form.find('.prepay-notice'),
		    $rate_type          = $form.find('#hotelbooking-rate_type'),
		    $payment_time       = $form.find('#hotelbooking-payment_time');

		Adzuki.Typeahead(
			'#hotelbooking-merge_into_reservation',
			'/Searches/recipient/reservation/',
			function selected(item, $self, typeahead) {
				typeahead.setHiddenValue(item.id);
			}
		);

		// if selecting an existing client, get their cc info to pre-fill fields
		$(".existing-client.adzuki-typeahead").on('ta.set-hidden', function getClientCCs(e, client_id) {
			$saved_cards.get(0).options.length = 1;

			fetchClientCreditCards(client_id);

			Adzuki.Ajax.get('/Clients/getPhoneNumbers/'+client_id)
			.then(function fillClientPhone(phone_data)
			{
				if (['H', 'W'].indexOf(phone_data.type_abbrev) >= 0) {
					$('#hotelbooking-phone_number_type').val(phone_data.type_abbrev);
				} else {
					$('#hotelbooking-phone_number_type').val('O');
				}

				$('#hotelbooking-phone_number').val(phone_data.primary);
			});

			if ($('#hotelbooking-email_address').length) {
				Adzuki.Ajax.get('/Clients/getClientEmail/'+client_id)
				.then(function fillClientEmail(email_data) {
					$('#hotelbooking-email_address').val(email_data[client_id]);
				});
			}
		})
		.on('ta.reset', function resetCCField() {
			$saved_cards_parent.addClass('hidden');
			$saved_cards.get(0).options.length = 1;
			$('#hotelbooking-phone_number').val('');
			$('#hotelbooking-email_address').val('');
			$("#hotelbooking-name_on_credit_card").val('');
			$("#hotelbooking-credit_card_type").val('');
			$("#hotelbooking-credit_card_type_branch_id").val('');
			$("#hotelbooking-credit_card_number").val('');
			$("#hotelbooking-credit_card_cvv").val('');
			$("#hotelbooking-expiration_date").data('DateTimePicker').clear();
			$("#hotelbooking-address1").val('');
			$("#hotelbooking-address2").val('');
			$("#hotelbooking-city").val('');
			$("#hotelbooking-state").val('');
			$("#hotelbooking-zip").val('');
		});

		$saved_cards.on('change', function fetchCCData() {
			if (this.value) {
				Adzuki.Ajax.get('/ClientCreditCards/get/'+this.value+'/1/1')
				.then((cc_info) => fillBillingInfo(cc_info));
			} else {
				fillBillingInfo({});
			}
		});

		Adzuki.CharacterCount('#hotelbooking-special_preferences', {
			max  : ($form.hasClass('expedia') ? 250 : 120),
			label: '#special-preferences-count',
		});

		$cc_card_type.on('change', function showAmexTypes() {
			displayAmexCardTypes(this.value === 'AX');
		});

		// re-fetch saved credit card info if a booking fails
		if ($existing_client_id.val()) {
			fetchClientCreditCards($existing_client_id.val());
		}

		// reset existing client when 'new client' is selected,
		// which also clears out cc info (ADZ-4625)
		$('.new-or-existing').on('change', function test() {
			if ($(this).val() === 'new') {
				$('.reset-typeahead a').click();
			}
		});

		$payment_time.on('change', function showPrepayMessage() {
			$prepay_notice.toggleClass('hidden', this.value !== 'prepay');
		});

		// click on "Verify Card"
		$cc_verify.on('click', function verifyCard(e)
		{
			var $self   = $(this),
			$loaderIcon = $self.siblings('span.fa'),
			$inputGroup = $self.closest('.input-group'),
			cardNumber  = $.trim($cc_number.val());

			e.preventDefault();
			e.stopPropagation();

			if (cardNumber === '') {
				Adzuki.StatusMessage(
					'error',
					'<p class="text-bold" style="font-size: 16px;">Card Verification Error<p>'
					+ 'Card Number must be provided.'
				);
				return;
			}

			$loaderIcon.removeClass('hidden');
			$inputGroup.removeClass('has-error');
			$self.addClass('disabled');
			$cc_number.prop('readonly', true);
			// $cc_verified.val('0');

			Adzuki.Ajax.post('/HotelBooking/verifyCard', {
				cardNumber: cardNumber
			})
			.then(function onVerifyCardSuccess(response)
			{
				var cardName;

				$loaderIcon.addClass('hidden');

				if (response.status === false) {
					throw new Error(response.error);
				}

				if (typeof response.card_name === 'string') {
					cardName = response.card_name.replace('American Express', '');

					if (response.prepaid_eligible === true && parseInt($('#hotelbooking-no_prepay').val()) !== 1) {
						$('.form-group.payment-time select').removeAttr('disabled');
					}

					// $cc_verified.val('1');

					$cc_card_info.removeClass('hidden');
					$cc_card_info.find('.card-text')
					.html(cardNumber + ' (' + cardName + ')');

					$amex_card_types.find('option')
					.attr('selected', false)
					.each(function setAmexCardType(key, item)
					{
						var card_option_val  = $(item).val();
						var card_option_name = $(item).text().trim();

						if (card_option_val !== '' && _validCardName(cardName, card_option_name)) {
							$(item).attr('selected', true);
							$amex_card_types.val(card_option_val);
							return false; // break
						}
					});

					if ($rate_type.val() !== 'FHR') {
						$payment_time.val('');
					}

					$cc_card_type.find('option').attr('selected', false);
					$cc_card_type.find('option[value="AX"]').attr('selected', true);
					$cc_card_type.val($cc_card_type.find('option[selected]').val());
					$cc_card_type.trigger('change');

					if ($amex_card_types.find('option[selected]').length === 0) {
						Adzuki.StatusMessage(
							'warning',
							'NOTE: The entered card appears to be a '
							+ cardName
							+ '. Please ensure your Amex Card Type selection is correct.'
							+ '<br><br>You will still be able to submit your booking.'
						);

						return;
					}
				}

				Adzuki.StatusMessage(
					'success',
					'Your card has been successfully verified!'
				);
			})
			.catch(function onVerifyCardFailure(error)
			{
				var errorMsg;

				if (typeof error === 'string') {
					errorMsg = error;
				} else {
					errorMsg = error.message;
				}

				if ($rate_type.val() !== 'FHR') {
					$payment_time.attr('disabled', true);
				}

				$inputGroup.addClass('has-error');
				$self.removeClass('disabled');
				$cc_number.prop('readonly', false);
				// $cc_verified.val('0');

				Adzuki.StatusMessage(
					'error',
					'Unable to verify card:<br><br><ul><li>'
						+ errorMsg
						+ '</li></ul>'
				);
			});
		});

		// click on "Remove Card" once it's verified
		$cc_remove_card.on('click', function removeVerifiedCard(e)
		{
			e.preventDefault();

			// $cc_verified.val('0');
			$cc_number.prop('readonly', false).val('');
			$cc_verify.removeClass('disabled');
			$cc_card_info.addClass('hidden')
			.find('.card-text').html('');
		});

		function displayAmexCardTypes(should_display) {
			if (should_display) {
				$amex_card_types.removeClass('hidden');
			} else {
				$amex_card_types.addClass('hidden');
			}
		}

		function fetchClientCreditCards(client_id) {
			Adzuki.Ajax.get('/ClientCreditCards/getCardsByClientId/'+client_id+'/1/1')
			.then(function fillClientCCs(cc_data)
			{
				$saved_cards_parent.removeClass('hidden');
				$.each(cc_data, function populateCCSelect(sKey, sValue) {
					$saved_cards.append($('<option>').text(sValue).attr('value', sKey));
				});
			});
		}

		function fillBillingInfo(cc_info)
		{
			if (cc_info.number_token === null) {
				$cc_number.removeAttr('data-token');

				$('.cc-num-ss-link').addClass('hidden');
				$('.cc-num-span').removeClass('input-group');

				$cc_number.val('').focus();
			} else {
				$('.cc-num-span').addClass('input-group');
				$('.cc-num-ss-link').removeClass('hidden');

				$cc_number.attr('data-token', cc_info.number_token);

				Adzuki.SecureStorage.detokenize({
					secure_storage_tokens: [cc_info.number_token],
					success              : function success(plain_texts) {
						$cc_number.val(plain_texts[0]);

						if (!$cc_verify.hasClass('hidden')) {
							$cc_verify.click();
						}
					}
				});
			}

			$("#hotelbooking-name_on_credit_card").val(cc_info.name);
			$("#hotelbooking-credit_card_type").val(cc_info.credit_card_sabre_code).trigger('change');
			$("#hotelbooking-credit_card_type_branch_id").val(cc_info.credit_card_type_branch_id);
			$("#hotelbooking-address1").val(cc_info.address1);
			$("#hotelbooking-address2").val(cc_info.address2);
			$("#hotelbooking-city").val(cc_info.city);
			$("#hotelbooking-state").val(cc_info.state_iso);
			$("#hotelbooking-zip").val(cc_info.zip);

			if (Adzuki.is_mobile) {
				$("#hotelbooking-expiration_date").val(cc_info.expiration);
			} else {
				$("#hotelbooking-expiration_date").data('DateTimePicker').date(moment(cc_info.expiration));
			}
		}

		function _validCardName(cc_name, cc_option_name)
		{
			var card_name        = cc_name.toLowerCase();
			var card_option_name = cc_option_name.toLowerCase();

			if (
				(card_name.indexOf('platinum') !== -1 && card_option_name.indexOf('platinum') !== -1) ||
				(card_name.indexOf('centurion') !== -1 && card_option_name.indexOf('centurion') !== -1) ||
				(card_name.indexOf('gold') !== -1 && card_option_name.indexOf('gold') !== -1) ||
				(card_name.indexOf('other') !== -1 && card_option_name.indexOf('other') !== -1) ||
				(card_name.indexOf('co-brand') !== -1 && card_option_name.indexOf('other') !== -1)
			) {
				return true;
			}

			return false;
		}
	};
}(jQuery, window.Adzuki || {}));
